export default "__VITE_ASSET__CSrlFyGZ__"